/* © 2026 Trinchebalk */
(() => {
  const galleries = [...document.querySelectorAll('.tbp-gallery')];
  if (!galleries.length) return;
  const headers = [...document.querySelectorAll('.shopify-section-group-header-group')];
  const update = () => {
    const headerHeight = headers.reduce((height, header) => height + header.getBoundingClientRect().height, 0);
    const top = Math.ceil(headerHeight) + 12;
    galleries.forEach(gallery => {
      gallery.style.setProperty('--tb-gallery-top', `${top}px`);
      gallery.toggleAttribute('data-gallery-tall', gallery.getBoundingClientRect().height + top + 16 > innerHeight);
    });
  };
  const observer = new ResizeObserver(update);
  [...headers, ...galleries].forEach(node => observer.observe(node));
  window.addEventListener('resize', update, { passive: true });
  update();
})();
